module.exports = __webpack_public_path__ + "img/logo-lingehoeve1.a502565b.png";